<template>
    <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue-grey" class="header-action__button header-action__dialogBestrateicon" fab
            @click="handleCloseModal">
            <v-icon class="header-action__icon" dark color="white" style="font-size: 1.5rem;">
                mdi-window-close
            </v-icon>
        </v-btn>
    </v-card-actions>
    <v-card class="header-action__card dialogBestrateicon-box">
        <div class="bestRate-main-section">

            <h1>公式サイト「TIME SHARING」からの予約を <span> 最安値 </span> にしています</h1>
            <div class="bestRate-sub-section">

                <div class="bestRate-sub-title">
                    <!-- <img :src="titleLine" alt=""> -->
                    <h2>掲載しているスペースを予約できるサイト比較</h2>
                    <!-- <img :src="titleLine" alt=""> -->
                </div>

                <div class="body-box">
                    <div class="illustrated">
                        <ul>
                            <li class="illustrated-li">
                                <dl>
                                    <dt class="box-img">
                                        <span class="title-box title-span">公式サイト</span>
                                        <img class="sp-logo" :src="time_sharing_logo_sp"
                                            alt="TIME SHARING タイムシェアリング｜エリア・用途・人数から探せるスペース検索予約サイト" height="57" />
                                        <img class="pc-logo" :src="time_sharing_logo"
                                            alt="TIME SHARING タイムシェアリング｜エリア・用途・人数から探せるスペース検索予約サイト" width="244"
                                            height="49" />
                                    </dt>
                                    <dd>例：9,000円</dd>
                                </dl>
                            </li>
                            <li>
                                <dl>
                                    <dt class="title-box">比較 サイトA例</dt>
                                    <dd>例：10,000円</dd>
                                </dl>
                            </li>
                            <li>
                                <dl>
                                    <dt class="title-box">比較 サイトB例</dt>
                                    <dd>例：13,000円</dd>
                                </dl>
                            </li>
                            <li>
                                <dl>
                                    <dt class="title-box">比較 サイトC例</dt>
                                    <dd>例：11,500円</dd>
                                </dl>
                            </li>
                        </ul>
                    </div>
                </div>

                <div class="body-box-footer">
                    <p>スペースを予約できるサイトの料金設定は</p>
                    <div class="footer-description">
                        <span class="space-name">
                            公式サイト <img :src="time_sharing_logo" alt=""> が</span>
                        <span class="cheapest-price">最安値</span>となるように設定しています
                    </div>
                </div>
                <div class="spaces-marked">
                    <div class="best-rate-border-dotted"></div>
                    <div class="marked-description"><img :src="bestRateIcon" alt="">
                        <div class="flex items-besline gap-1 ">
                            <span>←</span><p class="new-spaces-marked">こちらのマークが付いたスペースが対象となります</p>
                        </div>
                    </div>
                    <div class="best-rate-border-dotted"></div>
                </div>

            </div>
            <div class="bestRate-bottom-section">
                <p>－ 最安値の対象外となる場合がございます －</p>
                <ul>
                    <li>法人契約料金など、一般には公示されていない料金</li>
                    <li>電話でしか予約を受け付けていない等、WEBサイト上で予約が出来ない料金</li>
                    <li>比較検索サイト（スペースマーケット・インスタベースなど）の独自のポイントやクーポン等の付与された特典を割引と見なした料金また、一部のスペースは最安値の対象外となります</li>
                </ul>
            </div>
        </div>
    </v-card>

</template>

<script setup>
import { defineProps, ref, defineEmits, watch } from 'vue';
import time_sharing_logo from "@/client/assets/images/time_sharing_logo.png";
import time_sharing_logo_sp from "@/client/assets/images/timesharingSP.png";
import bestRateIcon from "@/client/assets/images/bestrateIcon.png";
// import bestRateLine from "@/client/assets/images/bestRateLine.png";

const props = defineProps({
    isShowDialogBestRate: {
        type: Boolean,
    },
});
const isShowDialog = ref(props.isShowDialogBestRate);
const emit = defineEmits(["closeDialogBestRate"]);
watch(props, (value) => (isShowDialog.value = value.isShowDialogBestRate));
const handleCloseModal = () => {
    isShowDialog.value = false;
    emit("closeDialogBestRate");
};
</script>
<style lang="scss" scoped>
@import "./BestrateDialogCard.scss";
</style>
